<div [dlNodeVolger]="node" [cy]="cy" ankertype="rechtsonder" [offset]="{x: 5, y: 5}" [volgFormaat]="false" [schaalMetZoom]="false" [zichtbaarAls]="modelcanvas.nodeOverlaysZichtbaar" class="dl-nodemenu__holder" (pointerover)="opItemHover($event)" (pointerleave)="opMenuVerlaten()">
    <ul class="dl-nodemenu">
        @if (!condtag || node.data('condstate') === condtag.state) {
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lt" (click)="uitvoerChangeAction({type: 'd_ineq_lt'})" title="{{ 'ADD_INEQ_LT' | translate }}">
                <a class="q_ineq_lt"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_lte" (click)="uitvoerChangeAction({type: 'd_ineq_lte'})" title="{{ 'ADD_INEQ_LTE' | translate }}">
                <a class="q_ineq_lte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_eq" (click)="uitvoerChangeAction({type: 'd_ineq_eq'})" title="{{ 'ADD_INEQ_EQ' | translate }}">
                <a class="q_ineq_eq"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gte" (click)="uitvoerChangeAction({type: 'd_ineq_gte'})" title="{{ 'ADD_INEQ_GTE' | translate }}">
                <a class="q_ineq_gte"></a>
            </li>
            <li class="dl-nodemenu__item" data-uitleg="d_ineq_gt" (click)="uitvoerChangeAction({type: 'd_ineq_gt'})" title="{{ 'ADD_INEQ_GT' | translate }}">
                <a class="q_ineq_gt"></a>
            </li>
            <li class="dl-nodemenu__item" (click)="uitvoerSwitchArgs()" title="{{ 'SWITCH_ARGS' | translate }}">
                <a class="switch_args"></a>
            </li>
        }
        <li class="dl-nodemenu__separator dl-nodemenu__item"></li>
        <li class="dl-nodemenu__item" (click)="uitvoerEditBallon()" title="{{ 'BALLON.BTN_TITLE' | translate }}">
            <a class="fa_item"><span class="fa-regular fa-comment"></span></a>
        </li>
    </ul>
</div>
